import { artworkUrl } from "@/api/client";
import type { Item, ItemAttributes } from "@/types/api";

type ArtworkKind = "poster" | "backdrop";
type ArtworkOptions = { width?: number; format?: string; quality?: number; context?: string };

type ArtworkItemLike = {
  id: string;
  attributes: ItemAttributes;
};

function preferredArtworkPath(attrs: ItemAttributes, kind: ArtworkKind, context?: string): string | null {
  if (kind === "poster") {
    return context === "series"
      ? attrs.series_poster_artwork_path ?? attrs.poster_artwork_path ?? null
      : attrs.poster_artwork_path ?? null;
  }
  return context === "series"
    ? attrs.series_backdrop_artwork_path ?? attrs.backdrop_artwork_path ?? null
    : attrs.backdrop_artwork_path ?? null;
}

export function itemArtworkSrc(item: ArtworkItemLike, kind: ArtworkKind, opts?: ArtworkOptions): string {
  return withArtworkOptions(preferredArtworkPath(item.attributes, kind, opts?.context), opts)
    ?? artworkUrl(item.id, kind, opts);
}

export function itemArtworkContext(item: Item): string | undefined {
  const attrs = item.attributes;
  return attrs.item_type === "show"
    && attrs.series_title
    && attrs.series_id
    && attrs.series_id !== item.id
    ? "series"
    : undefined;
}

function withArtworkOptions(path: string | null, opts?: ArtworkOptions): string | null {
  if (!path) return null;

  const url = new URL(path, window.location.origin);
  if (opts?.width !== undefined) {
    url.searchParams.set("width", String(opts.width));
  }
  if (opts?.format !== undefined) {
    url.searchParams.set("format", opts.format);
  }
  if (opts?.quality !== undefined) {
    url.searchParams.set("quality", String(opts.quality));
  }
  if (opts?.context !== undefined) {
    url.searchParams.set("context", opts.context);
  }
  return url.toString();
}
